import { render, staticRenderFns } from "./MerchantRegistrationFormBuilder.vue?vue&type=template&id=5a17f52a&scoped=true&"
import script from "./MerchantRegistrationFormBuilder.vue?vue&type=script&lang=js&"
export * from "./MerchantRegistrationFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./MerchantRegistrationFormBuilder.vue?vue&type=style&index=0&id=5a17f52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a17f52a",
  null
  
)

export default component.exports